import { Alert } from 'react-native';
import Links from 'utils/links';
import Modal from 'utils/packages/Modal';
export const isStarlingBank = (bank) => /starling/i.test(bank?.name || '');
export const isStarlingJointBank = (bank) => isStarlingBank(bank) && /joint/i.test(bank?.name || '');
export const isStarlingPersonalBank = (bank) => isStarlingBank(bank) && !isStarlingJointBank(bank);
export const handleMyBankIsNotHere = (type) => {
    if (type === 'alert') {
        Alert.alert('Sorry to hear that 😭', 'If you don’t see your bank, we don’t currently support it. You can request it and check for updates on our community forum.', [
            {
                text: 'Visit community',
                onPress: Links.openEmmaCommunityBankIntegrations,
            },
            {
                text: 'Ok, thanks',
                style: 'cancel',
            },
        ]);
        return;
    }
    Modal.showConfirmation({
        title: 'Sorry to hear that 😭',
        subtitle: 'If you don’t see your bank, we don’t currently support it. You can request it and check for updates on our community forum.',
        confirmButtonTitle: 'Ok, thanks',
        cancelButtonTitle: 'Visit community',
        onPressCancel: Links.openEmmaCommunityBankIntegrations,
    });
};
export const BANK_APPS = {
    'American Express': {
        androidPackageName: 'com.americanexpress.android.acctsvcs.uk',
        iosUriScheme: 'amexapp',
    },
    'Bank of Scotland': {
        androidPackageName: 'com.grppl.android.shell.BOS',
        iosUriScheme: 'bos-retail',
    },
    Barclaycard: {
        androidPackageName: 'com.barclays.bca',
        iosUriScheme: 'launchbca',
    },
    'Barclays Bank': {
        androidPackageName: 'com.barclays.android.barclaysmobilebanking',
        iosUriScheme: 'launchbmb',
    },
    'Capital One': {
        androidPackageName: 'com.ie.capitalone.uk',
        iosUriScheme: 'capitalone',
    },
    'Chase UK': {
        androidPackageName: 'com.chase.intl',
        iosUriScheme: null,
    },
    'Danske Bank': {
        androidPackageName: 'com.danskebank.mobilebank3.uk',
        iosUriScheme: 'DBMobileBank3GB',
    },
    'First direct': {
        androidPackageName: 'com.firstdirect.bankingonthego',
        iosUriScheme: 'comfirstdirectbankingonthego',
    },
    'HSBC Bank': {
        androidPackageName: 'uk.co.hsbc.hsbcukmobilebanking',
        iosUriScheme: 'ukcomhsbcmobilebanking',
    },
    Halifax: {
        androidPackageName: 'com.grppl.android.shell.halifax',
        iosUriScheme: 'halifax-retail',
    },
    'Lloyds Bank': {
        androidPackageName: 'com.grppl.android.shell.CMBlloydsTSB73',
        iosUriScheme: 'lloyds-retail',
    },
    Monzo: {
        androidPackageName: 'co.uk.getmondo',
        iosUriScheme: 'monzo',
    },
    'Nationwide Building Society': {
        androidPackageName: 'co.uk.Nationwide.Mobile',
        iosUriScheme: 'nationwide',
    },
    Natwest: {
        androidPackageName: 'com.rbs.mobile.android.natwest',
        iosUriScheme: 'natwest',
    },
    PayPal: {
        androidPackageName: 'com.paypal.android.p2pmobile',
        iosUriScheme: 'paypal',
    },
    Revolut: {
        androidPackageName: 'com.revolut.revolut',
        iosUriScheme: 'revolut',
    },
    Santander: {
        androidPackageName: 'uk.co.santander.santanderUK',
        iosUriScheme: 'santanderretail',
    },
    'Starling Bank': {
        androidPackageName: 'com.starlingbank.android',
        iosUriScheme: 'starlingbank',
    },
    'TSB Bank': {
        androidPackageName: 'uk.co.tsb.newmobilebank',
        iosUriScheme: 'tsbmobile',
    },
    'Tesco Bank': {
        androidPackageName: 'com.tescobank.mobile',
        iosUriScheme: 'tescobank',
    },
    'The Co-operative Bank': {
        androidPackageName: 'com.cooperativebank.bank',
        iosUriScheme: 'coop',
    },
    'Triodos Bank UK': {
        androidPackageName: 'com.triodos.bankinguk',
        iosUriScheme: 'triodosmobilebankinguk',
    },
    'Virgin Money': {
        androidPackageName: 'com.virginmoney.uk.mobile.android',
        iosUriScheme: 'cs-com.virginmoney.uk.mobile.ios',
    },
    Wise: {
        androidPackageName: 'com.transferwise.android',
        iosUriScheme: 'tw',
    },
};
